import { Box, Toolbar } from '@mui/material'
import { Outlet } from 'react-router-dom'
import TopBar from './Topbar'
import Sidebar from './Sidebar'



export default function AppLayout() {
  return (
    <Box sx={{ display: 'flex' }}>
      {/* TopBar ติดบนสุด */}
      <TopBar />

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <Box component="main" sx={{ flexGrow: 1, p: 3,  }}>
        {/* Spacer ให้พอดีกับ TopBar */}
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  )
}
